"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.apwRetry = exports.retry = void 0;
const GqlError_1 = require("./GqlError");
const globalTypes_1 = require("../__generated__/globalTypes");
const retryIntervals = [1, 3, 5, 7];
function retry(p, shouldRetry) {
    let count = 0;
    let handle;
    return run();
    function run() {
        clearTimeout(handle);
        return new Promise((resolve, reject) => {
            p().then(resolve, (err) => {
                const interval = retryIntervals[count++] * 1000;
                if (!retryIntervals[count - 1]) {
                    reject(err);
                    return;
                }
                if (shouldRetry(err)) {
                    handle = setTimeout(() => {
                        run().then(resolve, reject);
                    }, interval);
                }
                else {
                    reject(err);
                }
            });
        });
    }
}
exports.retry = retry;
function apwRetry(p) {
    return retry(p, (e) => {
        if (e instanceof GqlError_1.ApwError) {
            return e.code == globalTypes_1.ErrorCodes.slow_down;
        }
        if (e instanceof GqlError_1.PxError) {
            return false;
        }
        if (e instanceof GqlError_1.GqlError) {
            return e.extensions.shouldRetry;
        }
        return true;
    });
}
exports.apwRetry = apwRetry;
